import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorSummary } from '@digdir/designsystemet-react';

import useRegistrationForm from '../useRegistrationForm';
import { useErrors } from '../utils';
import { hasInvalidArea } from '../../../store/registration/selectors';
import useSelector from '../../../hooks/useSelector';

const ErrorMessage: FC = () => {
  const { t } = useTranslation();
  const { step, startedObjectErrors } = useRegistrationForm();
  const { errors } = useErrors(step);
  const hasNegativeAreaError = useSelector(hasInvalidArea);

  if (!errors && Object.keys(startedObjectErrors).length === 0) {
    return null;
  }

  return (
    <ErrorSummary>
      <ErrorSummary.Heading>
        {t("register.errorMessage.description")}
      </ErrorSummary.Heading>
      <ErrorSummary.List aria-label={t('register.errorMessage.list')}>
        {errors &&
          Object.entries(errors).map(([field, fieldError]) => {
            const errorMessage = t(`register.errorMessage.field.${field}`, {
              context: fieldError.error,
              ...fieldError.values
            });

            return (
              <ErrorSummary.Item key={field} aria-label={errorMessage}>
                {errorMessage}
              </ErrorSummary.Item>
            );
          })}
        {startedObjectErrors &&
          Object.entries(startedObjectErrors).map(([field, numberedFieldError]) => {
            const errorMessage = t(`register.errorMessage.field.${field}`, {
              context: numberedFieldError?.fieldError
            });

            return (
              <ErrorSummary.Item key={field} aria-label={errorMessage}>
                {errorMessage}
              </ErrorSummary.Item>
            );
          })}
        {hasNegativeAreaError && <ErrorSummary.Item>{t('register.errorMessage.field.negativeCalculatedArea')}</ErrorSummary.Item>}
      </ErrorSummary.List>
    </ErrorSummary>
  );
};

export default ErrorMessage;
